import { Injectable } from '@angular/core';
import { AbstractDataProvider } from '@epicuro-next/data-providers/base-data-provider';
import { ProductService } from '@epicuro-next/data/product';
import { Observable } from 'rxjs';

@Injectable()
export class ProductProviderService implements AbstractDataProvider {
  constructor(private readonly productService: ProductService) {}

  public read<T>(property: string): Observable<T> {
    const [productId, brandId] = property.split(':');

    return this.productService.loadProduct(
      productId,
      brandId,
      true,
    ) as Observable<T>;
  }

  public write() {
    // for linter
  }
}
